<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-我的减重故事
-->

<template>
  <div class="page-main">
    <div class="tip">
      长按分享或保存图片
    </div>
    <div v-if="!url" class="info" id="reportCon">
      <div class="info-header">
        <div>
          <img class="rank-img" src="../assets/rank/paihangbang.png" />
        </div>
        <div>
          <img class="cup" src="../assets/rank/jiangbei.png" />
        </div>
      </div>

      <div class="info-body">
        <div class="main">
          <div class="main-text">
            <p class="main-text-p"></p>
            <p>排行榜</p>
          </div>
          <div>
            <div class="myAnwser">
              <div style="margin-left: 20px">
                {{ form.rankingNumber == 0 ? "--" : form.rankingNumber }}
              </div>
              <div class="headImg">
                <img class="user-header" v-if="form.url" :src="form.url" />
                <img v-else class="user-header" src="../assets/images/user.png" />
              </div>
              <div>
                {{ form.name }}
              </div>
              <div>
                {{ form.initialWeight }}kg
              </div>
              <div>
                {{ form.weight }}kg
              </div>
              <div style="margin-right: 10px">
                {{ form.lossWeightRateDes }}
              </div>
            </div>
            <div class="allScore list-header">
              <div class="item">排名</div>
              <div class="item" style="width: 22%;">昵称</div>
              <div class="item w_80">初始/最新体重</div>
              <div class="item">减重百分比</div>
              <div class="item w_22"></div>
            </div>
            <div class="allScore score-list" v-for="item in patients" data-item="item" :key="item.id">
              <div class="item">
                <div v-if="item.rankingNumber == 1">
                  <img class="rankingNumberImg" src="../assets/rank/jin.png" />
                  <!--                {{ item.sortNumber || 1 }}-->
                </div>
                <div v-else-if="item.rankingNumber == 2">
                  <img class="rankingNumberImg" src="../assets/rank/yin.png" />
                </div>
                <div v-else-if="item.rankingNumber == 3">
                  <img class="rankingNumberImg" src="../assets/rank/tong.png" />
                </div>
                <div v-else>{{ item.rankingNumber }}</div>
              </div>

              <div class="item" style="width: 22%;text-align: left;display: flex;align-items: center;">
                <img class="user-header" v-if="item.url" :src="item.url" />
                <img v-else class="user-header" src="../assets/images/user.png" />
                {{ item.name }}
              </div>
              <div class="item w_80">{{ item.initialWeight }}/{{ item.weight }}kg</div>
              <div class="item" >{{ item.lossWeightRateDes != null ? item.lossWeightRateDes : '0%' }}</div>
              <div class="item w_22"><img class="curve-icon" :src="curve_icon" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="img-box">
      <img :src="url" />
    </div>
    <div v-if="isRank == 2 || isRank == 0" class="info-header-back" @click="addRank">
      <div>加入</div>
      <div>排行榜</div>
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import curve_icon from '../assets/images/curve-icon.png'
export default {
  data() {
    return {
      curve_icon,
      url: false,
      form: {},
      isRank: 0,
      patients: []
    };
  },
  mounted() {
    document.title = '排行榜'
    this.id = getQueryString('id');
    this.isRank = getQueryString('isRank');
    // this.id = "1877168509061201921";
    // this.isRank = 1;

    this.getList();
  },

  methods: {
    getList() {
      ajax
        .Post({
          url: '/api/loss/lossWeight/selectPatientRankingList',
          data: { patientId: this.id }
        }).then(({ data: { success, data } }) => {
          if (success) {
            if (data.rankingList != null) {
              for (var i = 0; i < data.rankingList.length; i++) {
                data.rankingList[i].name = this.hideName(data.rankingList[i].name)
              }
              this.patients = data.rankingList.slice(0,20)
            }
            if (data.myInfo != null) {
              this.form = data.myInfo;
            }
            setTimeout(() => {
              this.saveImg()
            }, 500);
          }
        })
    },
    addRank() {
      this.url=false;
      ajax
        .Post({
          url: '/api/loss/patient/add/rank',
          data: { patientId: this.id, isRank: 1 }
        }).then(({ data: { success } }) => {
          if (success) {
            // wx.showToast({
            //   title: '已成功加入减重排行榜',
            //   icon: 'none',
            //   duration: 2000
            // })
            this.isRank = 1
            this.getList();
          }
        })
    },
    hideName(name) {
      if (name.length <= 1) {
        return name;
      }
      const surname = name.charAt(0);
      const hiddenPart = '*'.repeat(2);
      return surname + hiddenPart;
    },
    saveImg() {
      htmlToPDF('reportCon').then(url => {
        console.log("url", url)
        this.url = url
      });
    },

  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-main {
  width: 100%;
  height: auto;
}

.info {
  background-image: url("https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/1823527039955939329background.png?Expires=947803597701&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=sBuuDDLsiOe%2BWwxcC5rNrcugHVY%3D");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: auto;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 50px;
}

.info-header {

  height: 116px;
  padding-right: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}

.rank-img {
  width: 130px;
  height: 88px;
}

.cup {
  width: 110px;
  height: 116px;
}

.info-header-back {
  position: fixed;
  top: 72px;
  right: 10px;
  background-color: rgba(51, 51, 51, 0.25);
  /* 使用 rgba 设置背景透明度 */
  width: 48px;
  height: 48px;
  border-radius: 50%;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.info-header-back view {
  opacity: 1;
  /* 确保文字不透明 */
}



.info-body {
  height: calc(100% - 158px);
  display: flex;
  /* align-items: center; */
  justify-content: center;
  transform: translateY(8px);
}

.main {
  background-color: #ffffff;
  width: 100%;
  height: auto;
  border-radius: 15px;
  /* overflow-y: auto; */
  /* 垂直方向滚动条自动显示 */
  padding-left: 17px;
  padding-right: 17px;
  padding-bottom: 30px;
}

.main-text {
  margin-top: 15px;
  display: flex;
  align-items: center;
  font-size: 14px;

}

.main-text-p {
  background-color: #FBB341;
  width: 4px;
  height: 12px;
  margin-right: 10px;
}

.myAnwser {
  font-size: 14px;
  margin-top: 20px;
  width: 100%;
  height: 68px;
  background-color: #FEF8E3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FBB341;
  border-radius: 10px;
}

.headImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.user-header {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
}

.rankingNumberImg {
  width: 32px;
  height: 20px;
}

.allScore {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.item {
  text-align: center;
  /* flex: 1; */
  color: #333333;
  font-size: 14px;
  min-width: 40px;
}
.list-header .item{
  color: #A1A3A5;
  font-size: 12px;
}
.score-list {
  color: #333333;
  font-size: 14px
}

.filter-time-box {
  margin-top: 15px;
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  margin-bottom: 30px;
  font-size: 14px;
  align-items: center;
}

.filter-time-box-text {
  margin-right: 15px;
}

.filter-time-box>view .init-text {
  color: #999;
}

.filter-time-box-time {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  width: 197px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.time-span {
  display: inline-block;
  margin-left: 7px;
  margin-right: 7px;
}

.item-css {
  border-bottom: 1px solid #A1A3A5;
  padding-bottom: 3px;
  margin-bottom: 3px;
}

.img-box {
  width: 100%;
  height: auto;
}

.img-box img {
  width: 100%;
  height: auto;
}

.tip {
  color: #777;
  color: #FE5B59;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding: 20px 0;
}
.curve-icon{
  width: 20px;
  height: 11px;
}
.w_80{
  flex:80px;
}
.w_22{
  flex:22px;
}
</style>
